export function getDefaultCopyright(companyName: string = 'Print Shop Pricing'): string {
  return `© ${new Date().getFullYear()} ${companyName} · All rights reserved`;
}

export function getDefaultSettings(companyName: string = 'Print Shop Pricing') {
  return {
    companyName,
    applicationName: 'Print Shop Calculator',
    applicationTagline: 'Get instant pricing for your custom apparel',
    logoLightMode: '',
    logoDarkMode: '',
    logoUrl: ''
  };
}